// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1t2Rk","approved":"Status_approved__selYz","rejected":"Status_rejected__1mZbC","expired":"Status_expired__3zIYM","label":"Status_label__1Qaj1"};